import React from 'react';
import styles from './index.module.scss';

const AuthorCard = ({ publication }) => {
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState([]);
  const [pathToFolder, setPathToFolder] = React.useState('');

  React.useEffect(() => {
    if (!publication) return;
    setPublicationData(publication);
  }, [publication]);

  React.useEffect(() => {
    if (!publicationData) return;

    if (publicationData.content) {
      try {
        const parsed = JSON.parse(publicationData.content);
        setContentData(Array.isArray(parsed) ? parsed : []);
      } catch {
        setContentData([]);
      }
    } else {
      setContentData([]);
    }

    if (publicationData.path && publicationData.eng_name) {
      setPathToFolder(`https://${publicationData.path}${publicationData.eng_name}/`);
    }
  }, [publicationData]);

  const normalizeText = React.useCallback((value) => {
    if (typeof value !== 'string') return '';
    const text = value.trim();
    if (!text || text.toLowerCase() === 'none') return '';
    return text;
  }, []);

  const vm = React.useMemo(() => {
    if (!Array.isArray(contentData) || contentData.length === 0) {
      return { avatar: '', description: '', authorName: '' };
    }

    const firstBlock = contentData[0];
    const blockContent = Array.isArray(firstBlock?.block_content) ? firstBlock.block_content : [];

    const imageByImgType = blockContent.find((item) => {
      const type = (item?.cotent_type || item?.content_type || '').toLowerCase();
      const imgName = normalizeText(item?.img_name);
      return type === 'img' && imgName;
    });

    const imgsBlock = blockContent.find((item) => {
      const type = (item?.cotent_type || item?.content_type || '').toLowerCase();
      return type === 'imgs_block' && normalizeText(item?.imgs_names);
    });

    let avatarName = normalizeText(imageByImgType?.img_name);
    if (!avatarName && imgsBlock?.imgs_names) {
      try {
        const parsed = typeof imgsBlock.imgs_names === 'string' ? JSON.parse(imgsBlock.imgs_names) : imgsBlock.imgs_names;
        if (Array.isArray(parsed) && parsed.length > 0) {
          avatarName = normalizeText(String(parsed[0]));
        }
      } catch {
        avatarName = normalizeText(String(imgsBlock.imgs_names).split(',')[0]);
      }
    }

    if (avatarName.includes('\\')) {
      avatarName = avatarName.substring(avatarName.lastIndexOf('\\') + 1);
    }

    const descriptionBlock =
      blockContent.find((item) => {
        const tag = (item?.cotent_tag || item?.content_tag || '').toLowerCase();
        return (
          ['description', 'sphere', 'activity', 'about_author'].includes(tag) &&
          normalizeText(item?.content_text)
        );
      }) ||
      blockContent.find((item) => {
        const type = (item?.cotent_type || item?.content_type || '').toLowerCase();
        const text = normalizeText(item?.content_text);
        if (!text) return false;
        return type === 'text' || type === 'long_text';
      });

    const description = normalizeText(descriptionBlock?.content_text);
    const authorName =
      normalizeText(imageByImgType?.content_text) ||
      normalizeText(imgsBlock?.content_text) ||
      normalizeText(publicationData?.show_name);

    return { avatar: avatarName, description, authorName };
  }, [contentData, normalizeText, publicationData?.show_name]);

  if (!vm.avatar && !vm.description && !vm.authorName) return null;

  return (
    <section className={styles.authorCard}>
      {vm.avatar && pathToFolder && (
        <div className={styles.avatarWrap}>
          <img
            className={styles.avatar}
            src={`${pathToFolder}${vm.avatar}`}
            alt={vm.authorName || publicationData?.show_name || 'Автор'}
          />
        </div>
      )}

      <div className={styles.info}>
        {vm.authorName && <h3 className={styles.name}>{vm.authorName}</h3>}
        {vm.description && <p className={styles.description}>{vm.description}</p>}
      </div>
    </section>
  );
};

export default AuthorCard;
